import React, { Component } from "react";
import StarRatingComponent from "react-star-rating-component";

interface RatingProps {
    id: string;
    rating: number;
    onChange: (id: string, rating: number) => void;
}

class Rating extends Component<RatingProps, { rating: number }> {
    constructor(props: RatingProps) {
        super(props);
        this.state = {
            rating: props.rating,
        };
    }
    public render() {
        return (
            <StarRatingComponent
                name={this.props.id}
                starCount={5}
                value={this.state.rating}
                emptyStarColor="gray"
                onStarClick={this.onStarClick}
            />
        );
    }
    private onStarClick = (next: number, prev: number, name: string) => {
        this.setState({
            rating: next,
        });
        this.props.onChange(name, next);
    };
}

export default Rating;
